module.exports = __webpack_public_path__ + "static/media/estrela_dourada.cff248ad.svg";